import { useHolidays } from './useHolidays';
import { fmtDate, pad, getDaysInMonth, WEEKDAYS_ES, WEEKDAYS_EN } from './agendaConstants';
import { ApptChip } from './ApptChip';

export function MonthView({ date, appointments, studies, onClickAppt, onClickDay, lang }) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const daysInMonth = getDaysInMonth(year, month);
  const firstDay = new Date(year, month, 1).getDay();
  const startOffset = firstDay === 0 ? 6 : firstDay - 1;
  const studyMap = {};
  studies.forEach(s => { studyMap[s.study_id] = s; });
  const weekdays = lang === 'es' ? WEEKDAYS_ES : WEEKDAYS_EN;
  const today = fmtDate(new Date());
  const holidays = useHolidays();

  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  return (
    <div className="bg-white border border-stone-200 rounded-sm overflow-hidden">
      <div className="grid grid-cols-7 bg-stone-50 border-b border-stone-200">
        {weekdays.map(w => (
          <div key={w} className="p-2 text-center text-xs font-semibold text-stone-500">{w}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 divide-x divide-stone-100">
        {cells.map((day, i) => {
          if (!day) return <div key={i} className="min-h-[90px] bg-stone-50/50 border-b border-stone-100" />;
          const ds = `${year}-${pad(month + 1)}-${pad(day)}`;
          const dayAppts = appointments.filter(a => a.date === ds);
          const isToday = ds === today;
          return (
            <div key={i} data-testid={`month-cell-${ds}`} onClick={() => onClickDay(new Date(year, month, day))}
              className={`min-h-[90px] p-1 border-b border-stone-100 cursor-pointer hover:bg-stone-50 ${holidays[ds] ? 'bg-amber-50' : isToday ? 'bg-[#1f3e80]/5' : ''}`}>
              <p className={`text-xs font-semibold mb-1 ${isToday ? 'text-[#1f3e80]' : 'text-stone-700'}`}>{day}
                {holidays[ds] && <span className="ml-1 text-[10px] font-medium text-amber-700" data-testid={`month-holiday-${ds}`}>{holidays[ds]}</span>}</p>
              <div className="flex flex-wrap gap-0.5">
                {dayAppts.slice(0, 3).map(a => (
                  <div key={a.appointment_id} className={dayAppts.length > 1 ? 'flex-1 min-w-0' : 'w-full'}>
                    <ApptChip appt={a} study={studyMap[a.study_id]} onClick={onClickAppt} compact />
                  </div>
                ))}
                {dayAppts.length > 3 && (
                  <p className="text-[10px] text-stone-400 text-center">+{dayAppts.length - 3} {lang === 'es' ? 'mas' : 'more'}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
